import { motion, useReducedMotion } from "framer-motion";
import { ReactNode } from "react";
import { pageVariants, reducedMotionPageVariants } from "@/lib/animations";

interface PageTransitionProps {
  children: ReactNode;
}

export const PageTransition = ({ children }: PageTransitionProps) => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <motion.div
      initial="initial"
      animate="enter"
      exit="exit"
      variants={shouldReduceMotion ? reducedMotionPageVariants : pageVariants}
    >
      {children}
    </motion.div>
  );
};
